import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";
import {
  APIDeleteSuccessMsg,
  getItemDeleteSuccessMsg,
} from "../../../Constant/Message";
import DATA_TYPE from "../../../Constant/DataType";

toast.configure();

const deletePengumuman = async (axiosInstance, id) => {
  return await axiosInstance
    .delete(`pengumuman/${id}`)
    .then(() => {
      console.log(APIDeleteSuccessMsg);
      toast.success(getItemDeleteSuccessMsg(DATA_TYPE.Pengumuman), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    })
    .catch((error) => {
      console.error(error);
      toast.error(`DELETE (Pengumuman) ${error.message}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    });
};

export default deletePengumuman;
